// @flow

import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import LabeledInput from './LabeledInput'
import NativeSelect from '../../controls/NativeSelect'
import type { OptionType } from '../../types'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  clear: both;
  white-space: nowrap;
  ${(props) =>
    props.fullWidth
      ? `
      width: 100%;
    `
      : `
      width: 170px;
      padding-left: 10px;
    `};
`
const Header: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  justify-content: space-between;
`

type Props = {|
  className: string,
  header: string,
  options: Array<OptionType>,
  value: string,
  errors?: Array<string>,
  fullWidth?: boolean,
  disabled?: boolean,
  onChange: Function
|}

export default class SelectInput extends Component<Props> {
  render() {
    const { value, onChange, header, options, className, fullWidth, disabled } = this.props
    return (
      <Wrapper className="t-SelectInput" fullWidth={fullWidth}>
        <LabeledInput
          header={<Header>{header}</Header>}
          errors={this.props.errors}
          input={
            <NativeSelect
              options={options}
              className={className}
              value={value}
              htmlProperties={{ disabled }}
              onChange={(value) => onChange(value)}
            />
          }
        />
      </Wrapper>
    )
  }
}
